import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useGetStorageOrFetchIcon } from 'shared/api/hooks';
import { Skeleton } from '@mui/material';
import { ConverterIconsFromStringToSVG } from 'shared/components/icon/icon.user_icons_panel/converter_icon_from_string_to_svg';
export const LoadedIcon = (props) => {
    const { icon, active, ...rest } = props;
    const [responseIcon, run, loading, error, errorRun] = useGetStorageOrFetchIcon('get_icons_user');
    useEffect(() => {
        if (typeof icon === 'string') {
            //загружаем ОДНУ иконку загруженную пользователем
            run([icon]);
        }
    }, [icon]);
    if ((loading && error != null) || errorRun !== null) {
        return _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 32 });
    }
    return (_jsx(_Fragment, { children: responseIcon.map((el) => {
            return el.errorIcon ? (_jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 32 }, el.id)) : (_jsx(ConverterIconsFromStringToSVG, { fontSize: rest.fontSize ?? '3em', maintainColor: el.maintainColor, iconToString: el.icon }, el.id));
        }) }));
};
